import { render, staticRenderFns } from "./ArticleInnerCoverBack.vue?vue&type=template&id=2d3c8232&scoped=true"
import script from "./ArticleInnerCoverBack.vue?vue&type=script&lang=js"
export * from "./ArticleInnerCoverBack.vue?vue&type=script&lang=js"
import style0 from "./ArticleInnerCoverBack.vue?vue&type=style&index=0&id=2d3c8232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c8232",
  null
  
)

export default component.exports